import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import { type PersonFindInterface, PersonFindDto } from '@zaoblako/shared/modules/client/dtos/person/person-find.dto';
import { type Connection1cFindInterface, Connection1cFindDto } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { type BankDetailsFindInterface, BankDetailsFindDto } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-find.dto';
import { JurisdictionTypeEnum } from '@zaoblako/shared/modules/client/enums/jurisdiction-type.enum';
import { CurrencyFindDto, type CurrencyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';
import type { CompanyGroupFindInterface } from '@zaoblako/shared/modules/client/dtos/company.group/company-group-find.dto';

import * as yup from 'yup';

export interface CompanyFindInterface extends PersonFindInterface {
  connection: Connection1cFindInterface;
  taxationType?: TaxationTypeEnum;
  jurisdiction?: JurisdictionTypeEnum;
  group?: CompanyGroupFindInterface;
  allDocumentTypesAllowed?: boolean;
  bankDetails: BankDetailsFindInterface[];
  currencies: CurrencyFindInterface[];
}

export const CompanyFindDto = SerdeDtoClass.from<PersonFindInterface, CompanyFindInterface>(
  PersonFindDto,
  ClientDtoKeysEnum.COMPANY_FIND_DTO,
  {
    connection: {
      label: 'Соединение',
      nested: Connection1cFindDto,
      serializer: (_, nested) => nested,
    },
    taxationType: {
      optional: true,
      label: 'Тип налогообложения',
      serializer: yup
        .string()
        .oneOf(Object.values(TaxationTypeEnum)),
    },
    jurisdiction: {
      optional: true,
      label: 'Юрисдикция',
      serializer: yup
        .string()
        .oneOf(Object.values(JurisdictionTypeEnum)),
    },
    group: {
      optional: true,
      label: 'Группа',
      nested: ClientDtoKeysEnum.COMPANY_GROUP_FIND_DTO,
      serializer: (_, nested) => nested,
    },
    allDocumentTypesAllowed: {
      optional: true,
      label: 'Изменение всех типов документов',
      serializer: yup.boolean(),
    },
    bankDetails: {
      label: 'Реквизиты',
      nested: BankDetailsFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    currencies: {
      label: 'Валюты',
      nested: CurrencyFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
